import { Outlet } from "react-router-dom";

const ClientLedgerPaymentSchedules = () => <Outlet />;

export default ClientLedgerPaymentSchedules;
